/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const updatePatient = /* GraphQL */ `
  mutation UpdatePatient($input: UpdatePatientInput!) {
    updatePatient(input: $input) {
      id
      email
      countryId
      firstName
      lastName
      dateOfBirth
      gender
      sleepTestType
      startTherapyGroup
      userEnteredAhi
      phoneNumber
      aboutMeProgress
      myEquipmentProgress
      myHealthProgress
      overallProgress
      achievementsPushEnabled
      coachingPushEnabled
      coachingSmsEnabled
      coachingEmailEnabled
      cleaningPushEnabled
      cleaningSmsEnabled
      cleaningEmailEnabled
      smartCoachingEnabled
      stepCountSharingEnabled
      healthSharingEnabled
      healthSharingLastPromptedVersion
      shareDetailsWithProviderOptIn
      analyticsMode
      analyticsId
      pushToken
      timezoneId
      furiganaFamilyName
      furiganaGivenName
      marketingOptIn
      achievements {
        id
        name
        description
        imageUrl
        earnedDate
      }
      journeys
      firstTherapySessionDate
      lifetimeUsageHours
      processHealthDataOptIn
      streaksEnabled
      streaksPushEnabled
      announcementsPushEnabled
      accountCreationTime
      equipmentReplacementPushEnabled
      equipmentResupplyPushEnabled
      equipmentManagementEnabled
      heightInCentimeters
      heightInCm
      weightInKilograms
      weightInKg
      goalTrackingCompleted
    }
  }
`;
export const addFgDevice = /* GraphQL */ `
  mutation AddFgDevice($input: AddFgDeviceInput!) {
    addFgDevice(input: $input) {
      serialNumber
      deviceType
      deviceSeries
      deviceFamily
      lastSleepDataReportTime
      localizedName
      imagePath
      imageUrl
      fgDeviceManufacturerName
      fgDevicePatientId
      deviceSubtype
      manufacturer
      ptcsInfo {
        isEnabled
        firstEnabledDate
        recommendation {
          autoSetComfort
          rampEnable
          rampTime
          eprEnable
          eprType
          eprPressure
        }
        revertSettings {
          autoSetComfort
          rampEnable
          rampTime
          eprEnable
          eprType
          eprPressure
        }
      }
    }
  }
`;
export const addFlowGenerator = /* GraphQL */ `
  mutation AddFlowGenerator($input: AddFlowGeneratorInput!) {
    addFlowGenerator(input: $input) {
      serialNumber
      deviceType
      deviceSeries
      deviceFamily
      lastSleepDataReportTime
      localizedName
      imagePath
      imageUrl
      fgDeviceManufacturerName
      fgDevicePatientId
      deviceSubtype
      manufacturer
      ptcsInfo {
        isEnabled
        firstEnabledDate
        recommendation {
          autoSetComfort
          rampEnable
          rampTime
          eprEnable
          eprType
          eprPressure
        }
        revertSettings {
          autoSetComfort
          rampEnable
          rampTime
          eprEnable
          eprType
          eprPressure
        }
      }
    }
  }
`;
export const addFlowGeneratorV2 = /* GraphQL */ `
  mutation AddFlowGeneratorV2($input: AddFlowGeneratorInputV2!) {
    addFlowGeneratorV2(input: $input) {
      serialNumber
      # deviceType
      deviceSeries
      deviceFamily
      lastSleepDataReportTime
      localizedName
      imagePath
      imageUrl
      fgDeviceManufacturerName
      fgDevicePatientId
      deviceSubtype
      manufacturer
      ptcsInfo {
        isEnabled
        firstEnabledDate
        recommendation {
          autoSetComfort
          rampEnable
          rampTime
          eprEnable
          eprType
          eprPressure
        }
        revertSettings {
          autoSetComfort
          rampEnable
          rampTime
          eprEnable
          eprType
          eprPressure
        }
      }
    }
  }
`;
export const updateFlowGenerator = /* GraphQL */ `
  mutation UpdateFlowGenerator($input: UpdateFlowGeneratorInput!) {
    updateFlowGenerator(input: $input) {
      serialNumber
      deviceType
      deviceSeries
      deviceFamily
      lastSleepDataReportTime
      localizedName
      imagePath
      imageUrl
      fgDeviceManufacturerName
      fgDevicePatientId
      deviceSubtype
      manufacturer
      ptcsInfo {
        isEnabled
        firstEnabledDate
        recommendation {
          autoSetComfort
          rampEnable
          rampTime
          eprEnable
          eprType
          eprPressure
        }
        revertSettings {
          autoSetComfort
          rampEnable
          rampTime
          eprEnable
          eprType
          eprPressure
        }
      }
    }
  }
`;
export const addMask = /* GraphQL */ `
  mutation AddMask($input: AddMaskInput!) {
    addMask(input: $input) {
      maskManufacturerName
      maskCode
      maskType
      localizedName
      imagePath
      imageUrl
      maskPatientId
      cushionType
      manufacturer
      cushionMaterial
    }
  }
`;
export const updateMask = /* GraphQL */ `
  mutation UpdateMask($input: UpdateMaskInput!) {
    updateMask(input: $input) {
      maskManufacturerName
      maskCode
      maskType
      localizedName
      imagePath
      imageUrl
      maskPatientId
      cushionType
      manufacturer
      cushionMaterial
    }
  }
`;
export const removeFgDevice = /* GraphQL */ `
  mutation RemoveFgDevice($input: RemoveFgDeviceInput!) {
    removeFgDevice(input: $input) {
      serialNumber
      # deviceType
      deviceSeries
      deviceFamily
      lastSleepDataReportTime
      localizedName
      imagePath
      imageUrl
      fgDeviceManufacturerName
      fgDevicePatientId
      deviceSubtype
      manufacturer
      ptcsInfo {
        isEnabled
        firstEnabledDate
        recommendation {
          autoSetComfort
          rampEnable
          rampTime
          eprEnable
          eprType
          eprPressure
        }
        revertSettings {
          autoSetComfort
          rampEnable
          rampTime
          eprEnable
          eprType
          eprPressure
        }
      }
    }
  }
`;
export const removeMask = /* GraphQL */ `
  mutation RemoveMask($input: RemoveMaskInput!) {
    removeMask(input: $input) {
      maskManufacturerName
      maskCode
      maskType
      localizedName
      imagePath
      imageUrl
      maskPatientId
      cushionType
      manufacturer
      cushionMaterial
    }
  }
`;
export const clearNotifications = /* GraphQL */ `
  mutation ClearNotifications($input: [ClearNotificationInput!]!) {
    clearNotifications(input: $input) {
      id
      action
      title
      description
      positiveButtonTitle
      negativeButtonTitle
      url
      imageUrl
      negativeActionId
      negativeActionContent {
        title
        description
        positiveButtonTitle
        negativeButtonTitle
      }
      achievement {
        id
        name
        description
        imageUrl
        earnedDate
      }
    }
  }
`;
export const submitCCIData = /* GraphQL */ `
  mutation SubmitCCIData($input: CCIDataInput) {
    submitCCIData(input: $input)
  }
`;
export const addHealthMetric = /* GraphQL */ `
  mutation AddHealthMetric($input: HealthMetricDataInput!) {
    addHealthMetric(input: $input) {
      date
      metricValue
      metricType
    }
  }
`;
export const addHealthMetricV2 = /* GraphQL */ `
  mutation AddHealthMetricV2($input: HealthMetricDataInputV2!) {
    addHealthMetricV2(input: $input) {
      date
      metricValue
      metricType
    }
  }
`;
export const addHealthMetricSamples = /* GraphQL */ `
  mutation AddHealthMetricSamples($input: HealthMetricSampleInput!) {
    addHealthMetricSamples(input: $input) {
      ... on SleepMetricSample {
        startTime
        endTime
        sampleId
        stage
        shouldCountAsInBed
        recordedManually
        source {
          identifier
          productType
        }
      }
    }
  }
`;
export const dismissCard = /* GraphQL */ `
  mutation DismissCard($input: DismissCardInput!) {
    dismissCard(input: $input)
  }
`;
export const deleteHealthSamples = /* GraphQL */ `
  mutation DeleteHealthSamples($input: DeleteHealthSamplesInput!) {
    deleteHealthSamples(input: $input)
  }
`;
export const submitMaskAnswers = /* GraphQL */ `
  mutation SubmitMaskAnswers($input: MaskQuestionsInput!) {
    submitMaskAnswers(input: $input)
  }
`;
export const addSleepTest = /* GraphQL */ `
  mutation AddSleepTest($input: AddSleepTestInput!) {
    addSleepTest(input: $input)
  }
`;
export const updateResupplyInfo = /* GraphQL */ `
  mutation UpdateResupplyInfo($input: UpdateResupplyInfoInput!) {
    updateResupplyInfo(input: $input) {
      dueDate
      totalDays
      hmeInfo {
        id
        name
        phoneNumber
        email
        websiteUrl
        imageUrl
      }
    }
  }
`;
export const updatePTCSInfo = /* GraphQL */ `
  mutation UpdatePTCSInfo($input: UpdatePTCSInfoInput!) {
    updatePTCSInfo(input: $input) {
      isEnabled
      firstEnabledDate
      recommendation {
        autoSetComfort
        rampEnable
        rampTime
        eprEnable
        eprType
        eprPressure
      }
      revertSettings {
        autoSetComfort
        rampEnable
        rampTime
        eprEnable
        eprType
        eprPressure
      }
    }
  }
`;
export const bookRapidOrder = /* GraphQL */ `
  mutation BookRapidOrder($input: BookRapidOrderInput!) {
    bookRapidOrder(input: $input) {
      message
    }
  }
`;
